import React from "react"
import LegalLinks from "./LegalLinks"

const Footer = () => {
  return (
    <footer className="m-10 p-10 bg-F8F8F8">
      <div className="d-flex justify-content-between align-items-center">
        <LegalLinks />
      </div>
    </footer>
  )
}

export default Footer
